import React from "react";
import { animated, config, useSpring } from "@react-spring/web";
import i18n from "../../Helpers/i18n";
import { X } from "react-feather";
import Button from "~/assets/js/components/Button";
import headerMenuLinks from "./HeaderMenuLinks";
import PropTypes from "prop-types";
import useBodyScrollLock from "~/assets/js/Helpers/hooks/useBodyScrollLock";
import { useFeatureFlagVariantKey } from "posthog-js/react";

const HeaderSideMenu = ({ open, handleClose }) => {
    // Prevents body scroll when popup is open
    useBodyScrollLock(open);
    const isConfiguratorTextTest =
        useFeatureFlagVariantKey("your-salad") === "test";

    const transitionSide = useSpring({
        x: open ? 0 : 500,
        config: { ...config.molasses, duration: 400 },
    });

    if (open) {
        return (
            <>
                <div className="popup__backdrop" />
                <animated.div
                    style={transitionSide}
                    id="header-side-menu"
                    className="popup__wrapper">
                    <div className="side-menu__header">
                        <div className="side-menu__header__logo">
                            {reactConfig.logoUrl && (
                                <img
                                    id="pottsalat-logo"
                                    src={reactConfig.logoUrl}
                                    alt="pottsalat-logo"
                                    height={50}
                                    width={100}
                                />
                            )}
                        </div>
                        <div className="side-menu__header__close">
                            {handleClose && (
                                <span
                                    onClick={handleClose}
                                    style={{ cursor: "pointer" }}>
                                    <X size={48} />
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="side-menu__content">
                        <div className="side-menu__content__top-menu">
                            <div className="side-menu__content__button-container">
                                <Button
                                    label={i18n.t("header.toUser")}
                                    variant="primary"
                                    size="SM"
                                    onClick={() =>
                                        (location.href = "/mein-konto/")
                                    }
                                />
                            </div>
                            {headerMenuLinks.bottomMenu.map((link) => {
                                return (
                                    <a
                                        key={link.content}
                                        className="upper__menu__link "
                                        href={link.href}>
                                        {link.content}
                                    </a>
                                );
                            })}
                            {/* <a
                                className="upper__menu__link with-image"
                                href="/mein-potti/?source=navbar">
                                {isConfiguratorTextTest
                                    ? i18n.t("header.potti")
                                    : "Dein Potti"}
                                <img
                                    src="/wp-content/plugins/pottsalat/static/images/potti.webp"
                                    alt="potti"
                                />
                            </a>
                            <a
                                className="upper__menu__link with-image"
                                href="/meine-bowl/?source=navbar">
                                {i18n.t("header.bowl")}
                                <img
                                    src="/wp-content/plugins/pottsalat/static/images/bowl.webp"
                                    alt="bowl"
                                />
                            </a>
                            <a
                                className="upper__menu__link with-image"
                                href="/meine-ramen/?source=navbar">
                                {i18n.t("header.ramen")}
                                <img
                                    src="/wp-content/plugins/pottsalat/static/images/ramen.webp"
                                    alt="ramen"
                                />
                            </a> */}
                        </div>
                        <div className="side-menu__content__bottom-menu">
                            {headerMenuLinks.topMenu.map((link) => {
                                return (
                                    <a
                                        key={link.content}
                                        className="bottom__menu__link "
                                        href={link.href}>
                                        {link.content}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </animated.div>
            </>
        );
    }
    return null;
};

HeaderSideMenu.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};

export default HeaderSideMenu;
